module.exports = __webpack_public_path__ + "static/media/chrome-store.5d8be04c.svg";